import _ from "lodash";
import {  GET_SUBSCRIPTIONS_SUCCESS, GET_SUBSCRIPTIONS, CREATE_SUBSCRIPTION_FAIL,GET_SUBSCRIPTIONS_FAIL,
   CREATE_SUBSCRIPTION_SUCCESS, CREATE_SUBSCRIPTION, 
   DELETE_SUBSCRIPTION, DELETE_SUBSCRIPTION_SUCCESS, DELETE_SUBSCRIPTION_FAIL,
  UPDATE_SUBSCRIPTION, UPDATE_SUBSCRIPTION_SUCCESS, UPDATE_SUBSCRIPTION_FAIL,
   } from "../actions/subscription";
import { toast } from 'react-toastify';

 
const initialState = {
  subscriptions: [],
  isLoading:false,
  error:null
};

const SubscriptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTIONS_SUCCESS:
       return {
        ...state,
          subscriptions:action.subscriptions||[],
          isLoading:false,
          error:null

       };

       case GET_SUBSCRIPTIONS :
       return {
        ...state,
          isLoading:true,  error:null

       };

       case GET_SUBSCRIPTIONS_FAIL:
        toast.error("Failed to get subscriptions: " + action.error, {
         position: toast.POSITION.TOP_RIGHT
       });
       return{
         ...state,
         error:"Failed to get subscriptions: " + action.error,
         isLoading:false,

       }

       case CREATE_SUBSCRIPTION:
    
       return{
         ...state,
          isLoading:true,
          error:null

       } 
       
       case CREATE_SUBSCRIPTION_SUCCESS:
        toast.success("Subscription Created Successfully!: ", {
         position: toast.POSITION.TOP_RIGHT
       });
       return{
         ...state,
          isLoading:false,
         error:null

       } 

    case CREATE_SUBSCRIPTION_FAIL:
       toast.error("Failed to create subscription: " + action.error, {
        position: toast.POSITION.TOP_RIGHT
      });
      return{
        ...state,
        error:"Failed to create subscription: " + action.error,
        isLoading:false,

      }


      case UPDATE_SUBSCRIPTION:
    
      return{
        ...state,
         isLoading:true,
         error:null

      } 
      
      case UPDATE_SUBSCRIPTION_SUCCESS:
       toast.success("Subscription Updated Successfully!: ", {
        position: toast.POSITION.TOP_RIGHT
      });
      return{
        ...state,
         isLoading:false,
        error:null

      } 

   case UPDATE_SUBSCRIPTION_FAIL:
      toast.error("Failed To Update Subscription: " + action.error, {
       position: toast.POSITION.TOP_RIGHT
     });
     return{
       ...state,
       error:"Failed To Update Subscription: " + action.error,
       isLoading:false,

     }

     case DELETE_SUBSCRIPTION:
    
     return{
       ...state,
        isLoading:true,
        error:null

     } 
     
     case DELETE_SUBSCRIPTION_SUCCESS:
      toast.success("Subscription Deleted Successfully!: ", {
       position: toast.POSITION.TOP_RIGHT
     });
     return{
       ...state,
        isLoading:false,
       error:null

     } 

  case DELETE_SUBSCRIPTION_FAIL:
     toast.error("Failed To Delete Subscription: " + action.error, {
      position: toast.POSITION.TOP_RIGHT
    });
    return{
      ...state,
      error:"Failed To Delete Subscription: " + action.error,
      isLoading:false,

    }
    
    
    default:
      return state;
  }
};

export default SubscriptionsReducer;
